import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router'
import {AuthService} from './auth.service'

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      return true
    }

    console.debug('Not authenticated, redirecting to login...')
    this.router.navigate(['/auth'], {replaceUrl: true})
    return false
  }
}
